import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CustomLoader from "../../../../../Components/CustomLoader";
import ErrorMessage from "../../../../../Components/ErrorMessage";
import { AreaContext } from "../Context/AreaContext";
import TableBodyAreas from "./TableBody";
import TableHeadAreas from "./TableHead";
import {
  getComparator,
  stableSort,
} from "../../../../../Config/reuserFunctions";

export default function AreasTable() {
  const {
    query,
    setItemsSelected,
    itemsSelected,
    setIndeterminated,
  } = React.useContext(AreaContext);
  const { loading, data, error } = query;
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("area");

  const renderData = React.useMemo(
    () =>
      data
        ? stableSort(data?.obtenerAreas, getComparator(order, orderBy))
        : null,
    [order, orderBy, data]
  );

  if (loading) return <CustomLoader />;
  if (error) return <ErrorMessage />;

  const handleSelect = (checked, item) => {
    const items = [...itemsSelected];
    if (checked) items.push(item);
    if (!checked) {
      const indx = items.findIndex((elm) => elm._id === item._id);
      items.splice(indx, 1);
    }
    setItemsSelected(items);
    //revisar el checkAll
    if (items.length > 0 && items.length !== data.obtenerAreas.length) {
      setIndeterminated(true);
      return;
    }
    setIndeterminated(false);
  };

  const handleCheckAll = (checked) => {
    setIndeterminated(false);
    if (checked) {
      console.log(checked);
      setItemsSelected(data.obtenerAreas);
      return;
    }
    setItemsSelected([]);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden" }}>
      <TableContainer
        sx={{
          transition: "width .3s",
          height: { xs: `calc(100vh - 232px)`, sm: `calc(100vh - 130px)` },
          overflowX: "auto",
        }}
      >
        <Table stickyHeader size="small">
          <TableHeadAreas
            handleCheckAll={handleCheckAll}
            handleSort={handleSort}
            order={order}
            orderBy={orderBy}
          />
          <TableBodyAreas data={renderData} handleSelect={handleSelect} />
        </Table>
      </TableContainer>
    </Paper>
  );
}
